$(document).ready(function () {  
  /* ================= 반응형 체크 ============ */
  $(window).resize(function(){
    responsiveDevice();    /// pc, mobile 체크
    keyVisual();           /// keybisual( full )
    scrollHelpOnOff();     /// 스크롤 핼프 삭제
    hamburgerMenu();       /// 햄버거 
    languageMenu();        /// 다국어레이어

    gnbDeps2Height();      /// [2023-0919] Gnb dep2 높이 체크
    gnbDeps3Scroll();      /// [2023-0919] Gnb dep3 스크롤 생성
    gnbLocationHold();
    console.log("==============reisze============")
  });

  /*  */
  function responsiveDevice(){ 
    var _change_width = window.innerWidth; //  $(window).innerWidth(); //
    var _temp_width;
    //console.log(_change_width)
    if( _change_width >= 1024){
        _temp_width = "is_pc";
    }else{
        _temp_width = "is_mb";
    };
    trpUtilityChangeOnceFN(_temp_width, function($chang){
        $("body").removeClass("is_pc is_mb");
        $("body").addClass($chang);

        $(".is_mb .js-hamburger-list .colitem .dep2-list").hide();  // 햄버거 서브 메뉴
        //console.log("===================== read =====================")
    });
  }
  responsiveDevice();


  
  /* ============================================= header > menu : hover    */
  $(".js-hover_menu .menu-list li").hover(function(){
    var _w = $("span", this).innerWidth();
    var _l = $(this).position().left + 35 + (_w / 2);
    $(".js-hover_menu .bar").css({width: _w, left:_l}).addClass("on");
  }, function(){ 
    var _w = 0;
    $(".js-hover_menu .bar").css({width: _w}).removeClass("on");;
  })

  /* =============================================  [2023-0919] header > deps3아코디언 */
  $(".js-deps_accordion").trpAccordionMenu(".dep3_more > a" ,".dep3_con" , "on" , activeFn);
  function activeFn($index, $this){
    var _item  = $($this).closest(".dep3_more");
    var _con  =  $(".dep3_con",_item)
    console.log( $index ," : " , _item)

    if( _item.hasClass("on") ){ 
      _item.removeClass("on");
      _con.slideUp();
      return ;
    } // 활성화되어있으면 닫는다

    $(".js-deps_accordion .dep3_more").removeClass("on");
    _item.addClass("on");

    $(".js-deps_accordion .dep3_con").slideUp();
    _con.slideDown();
    return false;
  }
  

  $(".js-hamburger-btn").on("click",function($e){
    $e.preventDefault();
    $(".js-hamburger-list .colitem").removeClass("on");
    $(".js-hamburger-con").addClass("open");
    $("body").addClass("hamburger_open");
  })
  $(".js-hamburger-con .hamburger_close-btn").on("click",function($e){
    $e.preventDefault();
    $(".js-hamburger-con").removeClass("open");
    $("body").removeClass("hamburger_open");
  })


  /* sub menu */
  $(".js-hamburger-list").trpAccordionMenu(".js-dep1" ,".dep2-list" , "on", function($index){
    //console.log(">>> "+ $index)
    return true;
  });
  function hamburgerMenu(){
    //$(".is_pc .js-hamburger-list .colitem .dep2-list").show();
    //$(".is_pc .js-hamburger-list .colitem").removeClass("on");

    $(".is_pc .js-hamburger-con").removeClass("open");
    $(".is_pc").removeClass("hamburger_open");
  }
  

  /* ============================================= header > lang & location  */
  var lang_dropdown = $(".lang_dropdown-area .js-dropdown-btn").trpDropdown({ list : ".trp-dropdown_list-box" , area:".trp-dropdown-area"});
  $(".lang_dropdown-area .trp-dropdown_list-box a").on("click", function(){
    var _this = $(this);
    _this.closest(".lang_dropdown-area").find( ".select-btn span" ).text( _this.data("shot") );
    $(".lang_dropdown-area li").removeClass("active");
    _this.closest("li").addClass("active");
    lang_dropdown.getClose();
  });

  var location_dropdown = $(".location_dropdown-area .js-dropdown-btn").trpDropdown({ list : ".trp-dropdown_list-box" , area:".trp-dropdown-area"});
  $(".location_dropdown-area .trp-dropdown_list-box a").on("click", function(){
    var _this = $(this);
    _this.closest(".location_dropdown-area").find( ".select-btn span" ).text( _this.text() );
    location_dropdown.getClose();
  });


 
  /* sub language (버튼 , 컨테이너) */
  $(".js-language-list").trpAccordionMenu(".js-language" ,".language-list" , "on", function($index){
    //console.log(">>> "+ $index)
    return true;
  });
  function languageMenu(){
    $(".is_pc .js-language-list .colitem .language-list").show();
    $(".is_pc .js-language-list .colitem").removeClass("on");
  }



  /* [2023-0919] Gnb dep3스크롤 생성 */
  function gnbDeps3Scroll(){
    if( $(".responsive_scrollx .deps3-list").length ){
      var _position = $(".responsive_scrollx .deps3-list li.active").offset(); 
      $(".deps3-area .responsive_scrollx").animate( { scrollLeft: _position.left }, 0 );		
    }
  }

  function gnbLocationHold(){
    //var _holdH = $(".location-wrap").offset().top - 80;;
    $(window).on("scroll resize", function(){
      var _wST = $(window).scrollTop();
      var _holdH = 245 - 80;
      if( $("body").hasClass("is_mb") ){
        /// 모바일 크기
        _holdH = 150 - 50;
      }
      
      if( _wST >=  _holdH ){
        $(".location-wrap").addClass("scroll_hold")
      }else {
        $(".location-wrap").removeClass("scroll_hold")
      }
    })
  }



  /* ============================================= visual scroll */
  function trpScrollTop($selector, $add){
    var _position = $($selector).offset();
    $( 'html, body' ).animate( { scrollTop: _position.top + $add }, 500 );
  };
  $(".js-scroll_page1").on("click", function($e){ 
    $e.preventDefault();
    trpScrollTop("#scroll_page1" , 0 );
  })


  /* ================== kyvisual Full visual ====================== */
  function keyVisual(){
    if( $(".keyvisual-wrap .video-area").length ){
      trpFillLimitedFn(".keyvisual-wrap .video-area", ".keyvisual-wrap .youtube_player", 1280 , 720,  window.innerWidth,  window.innerHeight, -135, 0 );
    }
  }	
  keyVisual();


  /* ================== scroll X  help  ====================== */
  // 드래그 하면 아이콘 삭제 (touchmove)
  $(".responsive_scrollx").on("scroll", function($e){ 
    $(this).removeClass("help_on"); 
  });
  function scrollHelpOnOff(){ 
    $(".is_pc .responsive_scrollx").removeClass("help_on");
    $(".is_mb .responsive_scrollx").each( function(){
      console.log("scrollssss")
      $(this).hasScrollBar(); // ture of false
    }) 
  }
  $.fn.hasScrollBar = function() { 
    // 스크롤 있는지 여부 판단
    var _B =  (this.prop("scrollWidth") == 0 && this.prop("clientWidth") == 0)
    || (this.prop("scrollWidth") > this.prop("clientWidth"));
    _B ? $(this).addClass("help_on") : $(this).removeClass("help_on");
    return _B
    
  };
  $(".is_mb .responsive_scrollx").hasScrollBar();
  
}); // resize 


/* ================== gllery_viewpage Fn  ====================== */
function gallery_viewpageFN($this, $t , $c ){
  var _t = $t;
  var _c = $c;
  var _p = $c / $t * 100 + "%";
  if( $t < 10 ){ _t = "0" + _t; }
  if( $c < 10 ){ _c = "0" + _c; }
  $(".progress_bar .bar", $this).css({ width: _p });
  $(".progress_count .current", $this).text(_c)
  $(".progress_count .total", $this).text(_t)
}


/* 특정위치로 스크롤 */
function trpScrollTop($selector ){
  var _position = ""; 
  if( $("body").hasClass("is_pc") ){
    _position = Number($($selector).offset().top - ($(".gnb-wrap").innerHeight()) - ($(".location-wrap").innerHeight()) - 10);  
  }else{
    _position = Number($($selector).offset().top - ($(".gnb-wrap").innerHeight()) - 10);  
  }

  ///메뉴높이 
  console.log(_position)
  $( 'html, body' ).animate( { scrollTop: _position }, 350 );
};
  
  


/* [2023-0919] Gnb dep3스크롤 생성 */
function gnbDeps2Height(){
  var dep2H = $(".deps2-area").height();
  var dep3L = $(".deps3-list > li").length;
  if(dep2H >= 110 ){  // 2뎁스 높이 2줄
    $(".location_deps-wrap").addClass("type_line2");

    $(".top_guide").removeClass("dep3on dep2line2_dep3on");
    if(dep3L > 0  ){  // 3뎁스 겟수
      $(".top_guide").addClass("dep2line2_dep3on");
    }else{
      $(".top_guide").removeClass("dep2line2_dep3on");
    }
  }else if(dep2H >= 165 ){  // 3뎁스 높이 3줄
    $(".location_deps-wrap").addClass("type_line3");

    $(".top_guide").removeClass("dep3on dep2line3_dep3on");
    if(dep3L > 0  ){  // 3뎁스 겟수
      $(".top_guide").addClass("dep2line3_dep3on");
    }else{
      $(".top_guide").removeClass("dep2line3_dep3on");
    }
  }else{                    // 1줄
    $(".location_deps-wrap").removeClass("type_line2");

    $(".top_guide").removeClass("dep3on dep2line2_dep3on");
    if(dep3L > 0  ){  // 3뎁스 겟수
      $(".top_guide").addClass("dep3on");
    }else{
      $(".top_guide").removeClass("dep3on");
    }
  }

}
